// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace VertexToCustomerOrderLineApi {
	export async function importVertexFileToCustomerOrderLines(args: {
		customerOrderId: number;
		fileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/import/vertex/importVertexFileToCustomerOrderLines",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				fileHandle: args.fileHandle,
			},
		});
		return response as void;
	}
}
